<div class="main-section cx-one-ui">
    <div class="form-container cx-one-ui">
        <form [formGroup]="substringForm" id="reporting-set-data-field" *ngIf="showFields">
            <div class="input-field">
                <label for="add-input-field" id="input-field-label" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Input_Field">INPUT FIELD </label><span class="field-required"> * </span>
                <div class="add-input-field-container">
                    <div class="col-10 add-input-text">
                        <ng-container *ngIf="parentData?.childs[0]?.type; then addedItem else empty"></ng-container>
                    </div>
                    <ng-container *ngIf="parentData?.childs?.length > 0; then editIcon else addIcon"></ng-container>
                </div>
            </div>
            <div class="input-field">
                <label for="pattern-field" id="pattern-field-label" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Pattern">PATTERN</label><span class="field-required"> * </span>
                <cxone-text-input formControlName="pattern" type="text" class="text-input" textInputId="pattern-field"
                    [placeholder]="patternPlaceholder" name="pattern">
                </cxone-text-input>
            </div>
        </form>
    </div>
</div>
<ng-template #addIcon>
    <svg class="add-icon" (click)="addInput()">
        <use href="../App_Themes/CXone/icons/add.svg#add"></use>
    </svg>
</ng-template>
<ng-template #editIcon>
    <svg class="edit-icon" (click)="editInput(parentData?.childs[0])">
        <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
    </svg>
</ng-template>
<ng-template #addedItem>
    <span class="ellipsis-text" title="{{parentData?.childs[0]?.name}}">{{parentData?.childs[0]?.name}}</span>
</ng-template>
<ng-template #empty>
    <span class="text-color" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Input_Field_Placeholder">Add
        input</span>
</ng-template>